import { societyApi } from '@tubo/society-base'


societyApi.sealSys = {
  sealContentImg: '/api.sys/v1/seal/sys/seal_content/img/',

  // 印章信息-列表 详情
  content: '/api.sys/v1/sys/society/seal/content/:id',

  statSupervisor: '/api.sys/v1/sys/society/seal/stat/supervisor',

  aicAmend: '/api.sys/v1/seal/sys/aic/amend',

}

societyApi.sealSysRegister = {
  register: '/api.sys/v1/sys/society/seal/register/:id',
}

societyApi.gzwSys = {
  // 工商推送列表
  aic: '/api.sys/v1/gzw/sys/aic',

  // 公共网上查询-单位列表
  societySealOrg: '/api.sys/v1/sys/gzw/society/seal/org/:code',

  // 公共网上查询-印章列表
  societySealContent: '/api.sys/v1/sys/gzw/society/seal/content/:id',

  // 单位治安信息-列表
}

societyApi.webSysFree = {
  reservation: '/api.sys/v1/web/sys/free/reservation',
  opReservationCancel: '/api.sys/v1/web/sys/free/op/reservation/cancel/:id',
  opReservationConfirm: '/api.sys/v1/web/sys/free/op/reservation/confirm/:id',
  statLocale: '/api.sys/v1/web/sys/free/stat/locale',

  // 买单方管理
  payer: '/api.sys/v1/web/sys/free/payer/:id',

  // 网点管理
  locale: '/api.sys/v1/web/sys/free/locale/:id',

  // 套餐管理
  plan: '/api.sys/v1/web/sys/free/plan/:id',
}

export default societyApi

  //
  //     // 印章治安信息-根据USCC查询
  //     societySealContentUscc: '/api.sys/v1/sys/gzw/society/seal/content/uscc/:uscc',
  //
  //     // 印章治安信息-详情-XML
  //     societySealContentXml: '/api.sys/v1/sys/gzw/society/seal/content/xml/:id',
  //
  //     // 章模图片处理-上传
  //     opSealCv3: '/api/v1/sys/gzw/op/seal/cv3',
  //
  //     // 章模图片处理-获取
  //     opSealCv3ByMd5: '/api/v1/sys/gzw/op/seal/cv3/',
  //
  //     // 山东一窗通数据办结
  //     updateSdAicState: '/api.sys/v1/gzw/sys/update/sd_aic_state/:id',
  //
  //   },
  //
  //   //GZW-后台-电子公章
  //   sysGzwDz: {
  //     //电子公章-详情
  //     seal: '/api.sys/v1/gzw/dz/seal/:id',
  //     //电子公章-当前订单列表
  //     sealActive: '/api.sys/v1/gzw/dz/seal/active',
  //     //电子公章-用章单位待受理订单列表
  //     sealCenter: '/api.sys/v1/gzw/dz/seal/center',
  //     //电子公章-历史订单列表
  //     sealHistory: '/api.sys/v1/gzw/dz/seal/history',
  //     //电子公章-受理
  //     opAccept: '/api.sys/v1/gzw/dz/op/accept/:id',
  //     //电子公章-交付
  //     opDeliver: '/api.sys/v1/gzw/dz/op/deliver/:id',
  //     //电子公章-制作
  //     opMade: '/api.sys/v1/gzw/dz/op/made/:id',
  //     //电子公章-取消
  //     opCancel: '/api.sys/v1/gzw/dz/op/cancel/:id',
  //     //电子公章-取消制作
  //     opMadeCancel: '/api.sys/v1/gzw/dz/op/made_cancel/:id',
  //     //电子公章-退款
  //     opRefund: '/api.sys/v1/gzw/dz/op/refund/:id',
  //     //电子公章-根据印章编码查询印章信息
  //     querySealContent: '/api.sys/v1/gzw/dz/query/seal/content/:code',
  //     //电子公章-根据使用单位编码查询使用单位信息
  //     querySealOrg: '/api.sys/v1/gzw/dz/query/seal/org/:code',
  //     //电子公章-显示图片
  //     sealImg: '/api.sys/v1/gzw/dz/seal/img/',
  //     //电子公章-获取制作三所电子公章的json数据
  //     querySealJson3rd: '/api.sys/v1/gzw/dz/query/seal/json/3rd/:id',
  //     //电子公章-章模图片获取
  //     sealImgDown: '/api.sys/v1/gzw/dz/seal/img_down/'
  //   },
  //
  //   // GZW-后台统计
  //   sysGzwStat: {
  //
  //     // 按企业统计财务数据
  //     financeCompany: '/api.sys/v1/sys/gzw/stat/finance/company'
  //
  //   },
  //
  //   // ctrl-api-sys-society-hotel : SYS-SOCIETY-旅馆业
  //   sysSocietyHotel: {
  //
  //     record: '/api.sys/v1/sys/society/hotel/record/:id',
  //
  //     // 酒店预警-列表
  //     warn: '/api.sys/v1/sys/society/hotel/warn/:id',
  //
  //     // 酒店预警触发-列表
  //     warnTrigger: '/api.sys/v1/sys/society/hotel/warn/trigger/:id',
  //
  //     // 酒店报警触发-处置
  //     warnTriggerDispose: '/api.sys/v1/sys/society/hotel/op/warn/trigger/dispose',
  //
  //     // 酒店报警-列表
  //     alert: '/api.sys/v1/sys/society/hotel/alert/:id',
  //
  //     // 酒店报警触发-列表
  //     alertTrigger: '/api.sys/v1/sys/society/hotel/alert/trigger/:id',
  //
  //     // 酒店报警触发-处置
  //     alertTriggerDispose: '/api.sys/v1/sys/society/hotel/op/alert/trigger/dispose'
  //
  //   },
  //
  //   // SYS-CLIENT-STAT
  //   sysClientStat: {
  //
  //     // 特行企业工作统计
  //     reportCompany: '/api.sys/v1/sys/client/stat/report/company',
  //
  //     // 治安辖区工作统计
  //     reportPolice: '/api.sys/v1/sys/client/stat/report/police'
  //   },
  //
  //   // SYS-印章业务办理
  //   sysSocietySealBiz: {
  //     // 备案单-列表 / 新增
  //     papersRegister: '/api.sys/v1/sys/society/seal/register/:id',
  //
  //     // 使用单位-根据USCC查询
  //     sealOrgUscc: '/api.sys/v1/sys/society/seal/org/uscc',
  //
  //     // 使用单位-根据单位名称查询, 返回列表
  //     sealOrgName: '/api.sys/v1/sys/society/seal/org/name',
  //
  //     // 备案单-提交审核
  //     opPapersRegisterSubmit: '/api.sys/v1/sys/society/seal/register/op/submit/:id',
  //
  //     // 备案单-审核
  //     opPapersRegisterPermit: '/api.sys/v1/sys/society/seal/register/op/permit/:id',
  //
  //     // 备案单-修改文字(备案单信息和单位信息), 本接口不会修改印章信息
  //     opPapersRegisterAlter: '/api.sys/v1/sys/society/seal/register/op/alter',
  //
  //     // 备案单-修改印章  本接口不会修改备案单信息和单位信息
  //     opPapersRegisterSealAlter: '/api.sys/v1/sys/society/seal/register/op/seal/alter',
  //
  //     // 备案单-复核
  //     opPapersRegisterReview: '/api.sys/v1/sys/society/seal/register/op/review/permit/:id',
  //
  //     // 备案单-根据备案单ID, 查询审核时可选的刻章企业
  //     queryPapersRegisterMaker: '/api.sys/v1/sys/society/seal/register/query/maker/:id',
  //
  //     // 备案单-打印
  //     papersRegisterPrint: '/api.sys/v1/sys/society/seal/register/print/:id'
  //
  //   },
  //
  //   // 系统-印章-信息查询
  //   sysSocietySeal: {
  //
  //     // 印章信息-列表 详情
  //     content: '/api.sys/v1/sys/society/seal/content/:id',
  //
  //     // 印章信息-显示章模图片
  //     contentImg: '/api.sys/v1/sys/society/seal/content/img/',
  //
  //     // 使用单位-列表 详情
  //     org: '/api.sys/v1/sys/society/seal/org/:id',
  //
  //     // 印章信息-根据uscc查询某个使用单位全部印章
  //     contentOrg: '/api.sys/v1/sys/society/seal/content/org/:uscc'
  //   },
  //
  //   // SYS-SEAL-作废单管理
  //   sysSocietySealDiscard: {
  //     // 作废单列表 操作
  //     discard: '/api.sys/v1/sys/society/seal/discard/:id',
  //     // 作废单 - 审核
  //     permit: '/api.sys/v1/sys/society/seal/discard/permit/:id',
  //     // 作废单 - 打印
  //     print: '/api.sys/v1/sys/society/seal/discard/print/:id',
  //     // 作废单 - 提交审核
  //     submit: '/api.sys/v1/sys/society/seal/discard/submit/:id',
  //   },
  //
  //   // SOCIETY-SEAL-统计
  //   sysSocietySealStat: {
  //     //系统后台-刻章店业务统计
  //     biz: '/api.sys/v1/sys/society/seal/stat/biz',
  //     //系统后台-刻章店当前业务概况
  //     bizCur: '/api.sys/v1/sys/society/seal/stat/biz/cur',
  //     //系统后台-治安辖区工作统计
  //     police: '/api.sys/v1/sys/society/seal/stat/police'
  //   }

